  document.addEventListener('DOMContentLoaded', function() {
  const tabsContainer = document.querySelector('.product-tabs');
  if (!tabsContainer) return;
  
  const tabLinks = tabsContainer.querySelectorAll('.tabs-navigation__link');
  
  // Función para cambiar de tab
  function switchTab(targetTab) {
    // Remover clases activas
    tabLinks.forEach(link => {
      link.classList.remove('active');
      link.setAttribute('aria-selected', 'false');
    });
    
    // Activar tab seleccionada
    const activeLink = tabsContainer.querySelector(`[data-tab="${targetTab}"]`);
    
    if (activeLink) {
      activeLink.classList.add('active');
      activeLink.setAttribute('aria-selected', 'true');
      window.location.href = activeLink.href;
    }
  }
  
  // Event listeners para las tabs
   tabLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const targetTab = this.getAttribute('data-tab');
      switchTab(targetTab);
      
        const headerOffset = 80; 
        const elementPosition = targetElement.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        if (window.innerWidth < 1024) {
        this.scrollIntoView({ 
          top: offsetPosition,
          behavior: 'smooth', 
          block: 'nearest', 
          inline: 'center' 
        });
      }
    });
  });
  });